import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'

import StyledPhoneInput from 'components/Form/StyledPhoneInput/StyledPhoneInput'
import FixedBottomButton from 'components/UI/FixedBottomButton/FixedBottomButton'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import { AllIcons } from 'helpers/allIcons'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { SuccessfulChange } from 'pages/settings/features/SuccessfulChange'
import { editProfileInfo } from 'services/endpoints/settings/account/profileSettings'
import { useSetUserProfile, useUserProfile } from 'store'

export const ChangePhone = () => {
  const [newPhone, setNewPhone] = useState('')
  const [isEditing, setIsEditing] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const navigate = useNavigate()
  const userData = useUserProfile()
  const { t } = useTranslation()

  const maskedPhone = userData?.phone_number
    ? `*******${userData.phone_number}`
    : ''

  const userCountryName = userData?.country_name ?? ''

  const submitFn = (phoneNumber: string) => {
    if (phoneNumber.length > 4 && phoneNumber.length < 16) {
      updatePhoneNumber.mutate({
        phone_number: phoneNumber
      })
    }
  }

  const handlePhoneFocus = () => {
    if (isEditing) return

    setNewPhone('')
    setIsEditing(true)
  }


  const updatePhoneNumber = useMutation(
    async ({ phone_number }: { phone_number: string }) => {
      return await editProfileInfo(
        { phone_number },
        'phone-number'
      )
    },
    {
    onSuccess: () => {
      useSetUserProfile({
        phone_number: newPhone.slice(-4)
      })

      setCurrentPage(2)
    }
    }
  )

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 1:
        return (
          <StyledPhoneInput
            customClass='change-phone-input'
            phone={newPhone}
            setPhone={setNewPhone}
            maskedPhone={isEditing ? '' : maskedPhone}
            countryName={userCountryName}
            onFocus={handlePhoneFocus}
          />
        )

      case 2:
        return (
          <SuccessfulChange
            img={AllIcons.settings_mobile_big}
            text={t('yourPhoneNumberHasSuccessfullyChanged')}
          />
        )

      default:
        return null
    }
  }

  const renderBottomButton = () => {
    switch (currentPage) {
case 1:
  return (
    <FixedBottomButton
      customClass='accountsettings__card__fixedbottombtn'
      text={t('save')}
      disabled={
        !isEditing ||
        newPhone.length <= 4 ||
        newPhone.length >= 16
      }
      clickFn={() => {
        submitFn(newPhone)
      }}
      secondaryText={isEditing ? t('cancel') : undefined}
      secondaryClickFn={() => {
        setNewPhone('')
        setIsEditing(false)
      }}
    />
  )

      case 2:
        return (
          <FixedBottomButton
            customClass='accountsettings__card__fixedbottombtn'
            text={t('close')}
            clickFn={() => {
              navigate('/settings/account')
            }}
          />
        )

      default:
        return null
    }
  }

  return (
    <WithHeaderSection
      headerSection={
        <LayoutHeader
          type='basic'
          section={t('account')}
          title={t('settings:changePhoneNumber')}
        />
      }
    >
      <>
        {renderCurrentPage()}
        {renderBottomButton()}
      </>
    </WithHeaderSection>
  )
}
